var sony_projector_RM_PJ28 = {
    name: "Projector RM PJ28",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [95,0,5,174,2,236,1,1,5,242,1,173,9,248,1,178,2,168,81,172,2,0,0,45,190,218,37,183,219,68,182,251,104,64],
        },
        {
            // function: "KEY_INPUT",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [95,0,5,255,4,242,1,173,2,238,1,177,9,1,2,179,2,247,76,173,2,0,0,61,181,182,39,182,182,196,246,214,216,64],
        },
        {
            function: "KEY_FILM1",
            name: "KEY_FILM1",
            icon: "KEY_FILM1",
            command: [125,0,5,0,5,242,1,171,2,236,1,178,9,245,1,177,2,32,49,170,2,0,0,58,219,118,218,39,91,110,219,68,235,109,219,104,64],
        },
        {
            function: "KEY_FILM2",
            name: "KEY_FILM2",
            icon: "KEY_FILM2",
            command: [125,0,5,173,2,239,1,254,4,242,1,169,9,234,1,171,2,124,51,179,2,0,0,61,109,173,182,39,173,181,182,196,245,182,182,216,64],
        },
        {
            function: "KEY_REF",
            name: "KEY_REF",
            icon: "KEY_REF",
            command: [125,0,5,249,4,241,1,170,2,243,1,182,9,250,1,176,2,29,49,169,2,0,0,54,219,118,218,38,219,110,219,68,219,109,219,104,64],
        },
        {
            function: "KEY_TV",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [125,0,5,168,2,239,1,251,4,244,1,175,9,253,1,181,2,120,51,180,2,0,0,55,109,173,182,38,237,181,182,196,221,182,182,216,64],
        },
        {
            function: "KEY_PHOTO",
            name: "KEY_PHOTO",
            icon: "KEY_PHOTO",
            command: [125,0,5,249,4,242,1,169,2,241,1,186,9,253,1,188,2,207,46,174,2,0,0,61,182,237,180,79,109,187,109,19,219,110,219,66],
        },
        {
            function: "KEY_GAME",
            name: "KEY_GAME",
            icon: "KEY_GAME",
            command: [114,0,9,251,1,168,2,248,1,252,4,4,5,239,1,179,2,241,1,178,9,248,1,176,2,34,49,185,2,47,161,47,49,162,9,50,0,169,2,8,146,36,72,145,36,72,145,34,8,68,144,53,182,224,52,2,219,91,110],
        },
        {
            function: "KEY_BRTCINE",
            name: "KEY_BRTCINE",
            icon: "KEY_BRTCINE",
            command: [125,0,5,253,4,243,1,169,2,239,1,185,9,249,1,175,2,19,49,171,2,0,0,53,219,118,218,38,187,110,219,68,215,109,219,104,64],
        },
        {
            function: "KEY_BRTTV",
            name: "KEY_BRTTV",
            icon: "KEY_BRTTV",
            command: [125,0,5,168,2,236,1,252,4,244,1,178,9,243,1,177,2,118,51,164,2,0,0,47,109,173,182,37,237,181,182,196,189,182,182,216,64],
        },
        {
            function: "KEY_USER",
            name: "KEY_USER",
            icon: "KEY_USER",
            command: [125,0,5,167,2,244,1,251,4,244,1,169,9,255,1,172,2,128,51,175,2,0,0,59,109,173,182,39,109,181,182,196,237,182,182,216,64],
        },
        {
            // function: "KEY_PATTERN",
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [125,0,5,255,4,241,1,171,2,239,1,171,9,245,1,174,2,38,49,170,2,0,0,42,251,118,218,37,95,110,219,68,171,237,219,104,64],
        },
        {
            // function: "KEY_RESET",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [95,0,5,253,4,240,1,173,2,241,1,181,9,247,1,179,2,152,74,176,2,0,0,59,235,108,78,250,219,19,190,182,194],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [95,0,5,0,5,240,1,174,2,239,1,179,9,249,1,183,2,68,79,167,2,0,0,54,234,219,19,110,173,177,54,234,219,8],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [95,0,5,171,2,238,1,2,5,243,1,174,9,247,1,178,2,169,81,156,2,0,0,59,94,218,39,107,219,68,237,123,104,64],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [95,0,5,254,4,240,1,175,2,239,1,177,9,0,2,179,2,67,79,156,2,0,0,58,234,219,19,174,173,177,58,234,219,8],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [95,0,5,173,2,238,1,0,5,243,1,174,9,253,1,180,2,85,79,156,2,0,0,53,175,109,19,90,246,209,53,175,109,8],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [95,0,5,175,2,239,1,1,5,238,1,177,9,248,1,175,2,79,79,156,2,0,0,54,183,109,19,107,118,209,54,183,109,8],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [95,0,5,175,2,239,1,253,4,242,1,177,9,253,1,177,2,157,81,156,2,0,0,46,222,218,37,219,219,68,187,123,104,64],
        },
        {
            function: "KEY_ASPECT",
            name: "KEY_ASPECT",
            icon: "KEY_ASPECT",
            command: [125,0,5,252,4,242,1,169,2,242,1,177,9,248,1,174,2,199,46,175,2,0,0,47,118,237,180,75,221,187,109,18,247,110,219,66],
        },
        {
            function: "KEY_MOTIONFLOW",
            name: "KEY_MOTIONFLOW",
            icon: "KEY_MOTIONFLOW",
            command: [95,0,5,174,2,237,1,255,4,242,1,174,9,254,1,176,2,243,83,171,2,0,0,45,253,180,75,127,109,18,223,219,66],
        },
        {
            function: "KEY_3D",
            name: "KEY_3D",
            icon: "KEY_3D",
            command: [167,0,5,255,4,229,1,174,2,233,1,181,9,246,1,183,2,197,46,177,2,0,0,59,214,237,180,78,245,187,109,19,189,110,219,68,239,91,182,208,128],
        },
        {
            function: "KEY_COLORSPACE",
            name: "KEY_COLORSPACE",
            icon: "KEY_COLORSPACE",
            command: [167,0,5,249,4,242,1,167,2,235,1,178,9,248,1,173,2,33,49,167,2,0,0,59,91,118,218,39,107,110,219,68,237,109,219,104,157,173,187,109,8],
        },
        {
            function: "KEY_COLORTEMP",
            name: "KEY_COLORTEMP",
            icon: "KEY_COLORTEMP",
            command: [167,0,5,249,4,242,1,165,2,240,1,177,9,252,1,169,2,32,49,170,2,0,0,43,219,118,218,37,123,110,219,68,175,109,219,104,149,237,187,109,8],
        },
        {
            function: "KEY_COLORCORRECTION",
            name: "KEY_COLORCORRECTION",
            icon: "KEY_COLORCORRECTION",
            command: [125,0,5,252,4,241,1,168,2,239,1,182,9,246,1,174,2,25,49,174,2,0,0,43,213,191,90,37,122,183,235,68,175,86,253,104,64],
        },
        {
            function: "KEY_GAMMACORRECTION",
            name: "KEY_GAMMACORRECTION",
            icon: "KEY_GAMMACORRECTION",
            command: [167,0,5,251,4,242,1,166,2,237,1,173,9,253,1,182,2,199,46,171,2,0,0,47,182,237,180,75,237,187,109,18,251,110,219,68,190,219,182,208,128],
        },
        {
            function: "KEY_CONTRASTENHANCER",
            name: "KEY_CONTRASTENHANCER",
            icon: "KEY_CONTRASTENHANCER",
            command: [127,0,5,173,2,234,1,255,4,239,1,177,9,246,1,180,2,155,81,173,2,0,0,42,254,218,37,95,219,68,171,251,104,149,127,109,8],
        },
        {
            function: "KEY_REALITYCREATION",
            name: "KEY_REALITYCREATION",
            icon: "KEY_REALITYCREATION",
            command: [167,0,5,168,2,240,1,253,4,244,1,175,9,251,1,175,2,124,51,172,2,0,0,58,237,173,182,39,93,181,182,196,235,182,182,216,157,118,214,219,8],
        },
        {
            function: "KEY_SHARPNESSUP",
            name: "KEY_SHARPNESSUP",
            icon: "KEY_SHARPNESSUP",
            command: [127,0,5,170,2,237,1,254,4,246,1,175,9,252,1,173,2,245,83,158,2,0,0,55,189,180,77,239,109,19,123,219,68,222,246,208,128],
        },
        {
            function: "KEY_SHARPNESSDOWN",
            name: "KEY_SHARPNESSDOWN",
            icon: "KEY_SHARPNESSDOWN",
            command: [127,0,5,167,2,236,1,2,5,245,1,179,9,251,1,172,2,161,81,173,2,0,0,43,222,218,37,123,219,68,175,123,104,149,239,109,8],
        },
        {
            // function: "KEY_BRIGHTNESSUP",
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [95,0,5,178,2,236,1,2,5,240,1,184,9,244,1,187,2,69,79,155,2,0,0,53,95,109,19,85,246,209,53,95,109,8],
        },
        {
            // function: "KEY_BRIGHTNESSDOWN",
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [95,0,5,2,5,240,1,177,2,236,1,180,9,245,1,181,2,248,76,157,2,0,0,63,85,182,39,234,182,196,253,86,216,64],
        },
        {
            // function: "KEY_CONTRASTUP",
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [95,0,5,174,2,239,1,3,5,239,1,176,9,249,1,174,2,242,83,175,2,0,0,61,125,180,79,95,109,19,215,219,66],
        },
        {
            // function: "KEY_CONTRASTDOWN",
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [95,0,5,174,2,237,1,3,5,239,1,190,9,252,1,183,2,138,81,181,2,0,0,46,190,218,37,215,219,68,186,251,104,64],
        },
    ]
}
export default sony_projector_RM_PJ28